import { render, staticRenderFns } from "./gscInvoiceCommon.vue?vue&type=template&id=4ad5ff0d&scoped=true"
import script from "./gscInvoiceCommon.vue?vue&type=script&lang=js"
export * from "./gscInvoiceCommon.vue?vue&type=script&lang=js"
import style0 from "./gscInvoiceCommon.vue?vue&type=style&index=0&id=4ad5ff0d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ad5ff0d",
  null
  
)

export default component.exports